import andrewPic from "@/public/images/artists/andrew.png";
import { Artist } from "@/types/types";

export const andrew = {
  id: "204",
  name: "Andrew",
  image: andrewPic,
  description: `Andrew has a warm, slightly husky tone that sits perfectly in acoustic mixes without getting buried. His conversational phrasing and gentle swagger give folk and Americana tracks an honest, lived-in feel.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fandrew-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Folk", "Indie", "Country", "Unprocessed", "Airy"],
      secondary: ["Americana"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 52,
        high: 68,
      },
      sweetSpot: 61,
    },
  },
} as const satisfies Artist;
